<div class="ap-margin-bottom-3">
    {{ 'renovation.button' | propertyTypePipe: (store.getPropertyType() | async) | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>

<ap-button-group id="renovationButton" [formControl]="mainApplicantControl" (buttonGroupClicked)="onButtonGroupClicked($event)">
    <ap-button-group-item label="{{ 'general.button-group.yes' | apContent }}" value="true"> </ap-button-group-item>
    <ap-button-group-item label="{{ 'general.button-group.no' | apContent }}" value="false"> </ap-button-group-item>
</ap-button-group>

<additional-info
    [key]="questionKey"
    titleKey="property.renovation.button.additional-info.text"
    contentKey="property.renovation.button.additional-info.content"
    modalUrlKey="property.renovation.button.additional-info.text"
></additional-info>
